/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const syncStatusResponseSchema = z.object({
  instanceId: z.string(),
  status: z.enum(['PENDING', 'IN_PROGRESS', 'DONE', 'FAILED']),
  type: z.enum([
    'JIRA_TEAM',
    'TEMPO_TEAM',
    'ADO_TEAM',
    'RESOURCE',
    'AVAILABILITY_SCHEME',
    'TEAM_ROLE',
    'SKILL',
  ]),
});
